import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import UpdateStationModal from "./UpdateStationModal";
import ajaxFuelPrices from "../../util/remote/ajaxFuelPrices";
import RegisterFuelPriceModal from "./RegisterFuelPriceModal";

const ViewFuelPrices = () => {
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [prices, setPrices] = useState([]);
  const [viewType, setViewType] = useState("table view");
  const [station_id, setstation_id] = useState(station_idd); // default

  const fetchPrices = async () => {
    setLoading(true);
    const data = { station_id };
    const response = await ajaxFuelPrices.list_Prices(data); // you might want to rename this to list_Prices
    if (response.status === "OK") {
      setPrices(response.details || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPrices();
  }, [station_id]);

  const toggleView = (type) => setViewType(type);

  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (price) => {
    setUpdate(false, () =>
      setUpdate(<UpdateStationModal data={price} func={fetchPrices} />)
    );
  };

  const [register, setRegister] = useStateCallback(false);
  const handleRegister = () => {
    setRegister(false, () =>
      setRegister(<RegisterFuelPriceModal func={fetchPrices} />)
    );
  };

  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Price",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-info btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);

  return (
    <AppContainer
      title="Fuel Prices"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {register}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Fuel Prices...
          </div>
        ) : prices.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Fuel Prices Available
          </div>
        ) : viewType === "table view" ? (
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="card-body">
                  <h6 className="card-title mb-1">Fuel Prices</h6>
                  <p className="text-muted card-sub-title">
                    List of adjusted fuel prices
                  </p>
                  <div className="table-responsive">
                    <table className="table table-bordered text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Station</th>
                          <th>Fuel</th>
                          <th>Selling Price</th>
                          <th>Date</th>
                          <th>Adjusted By</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prices.map((price, index) => (
                          <tr key={price.id}>
                            <td>{index + 1}</td>
                            <td>{price.station_name}</td>
                            <td>{price.fuel_category}</td>
                            <td>{price.selling_price}</td>
                            <td>{price.date}</td>
                            <td>{price.Adjusted_by}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => handleViewDetails(price)}
                              >
                                <i className="fe fe-edit-2"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {prices.map((price) => (
              <div className="col-md-4 col-lg-3 mb-3" key={price.id}>
                <div
                  className="card h-100"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body text-center">
                    <h6 className="mb-1">{price.fuel_category}</h6>
                    <small className="d-block text-muted">
                      Station: {price.station_name}
                    </small>
                    <small className="d-block text-muted">
                      Price: {price.selling_price}
                    </small>
                    <small className="d-block text-muted">
                      Date: {price.date}
                    </small>
                    <div className="mt-2">
                      <span className="badge bg-primary">
                        {price.Adjusted_by}
                      </span>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-sm btn-outline-primary px-3"
                        onClick={() => handleViewDetails(price)}
                      >
                        <i className="fe fe-edit-2"></i> Edit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppContainer>
  );
};

export default ViewFuelPrices;
